<template>

    <div class="min-h-screen bg-slate-100 pb-12">
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog class="relative z-50 lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                                 enter-from="opacity-0" enter-to="opacity-100"
                                 leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
                                 leave-to="opacity-0">
                    <div class="fixed inset-0 bg-slate-950/70 backdrop-blur-sm"/>
                </TransitionChild>

                <div class="fixed inset-0 flex min-h-0">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                                     enter-from="-translate-x-full" enter-to="translate-x-0"
                                     leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                                     leave-to="-translate-x-full">
                        <DialogPanel class="relative mr-16 flex min-h-0 w-full max-w-xs flex-1">
                            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                             enter-to="opacity-100" leave="ease-in-out duration-300"
                                             leave-from="opacity-100" leave-to="opacity-0">
                                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                                    <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                                        <span class="sr-only">Close sidebar</span>
                                        <XMarkIcon class="size-6 text-white" aria-hidden="true"/>
                                    </button>
                                </div>
                            </TransitionChild>
                            <!-- Barra laterale mobile -->
                            <div class="flex min-h-0 grow flex-col border-r border-white/10 bg-gradient-to-b from-indigo-950 via-indigo-900 to-indigo-900 pb-6 pl-6 pr-1 shadow-2xl">

                                <div class="admin-sidebar-menu-scroll -ml-2 min-h-0 flex-1 overflow-x-hidden overflow-y-auto pl-2 pr-3 pt-6">
                                    <!--
                                    <form class="mb-4" action="#" method="GET">
                                        <label for="mobile-sidebar-search" class="sr-only">Cerca</label>
                                        <input
                                            id="mobile-sidebar-search"
                                            type="search"
                                            name="search"
                                            class="block w-full rounded-lg border border-white/10 bg-white/10 px-3 py-2 text-sm text-white placeholder:text-indigo-200/70 focus:border-indigo-200/60 focus:outline-none focus:ring-2 focus:ring-indigo-200/20"
                                            placeholder="Cerca"
                                        />
                                    </form>
                                    -->

                                    <Menu></Menu>
                                </div>

                                <AdminSidebarUserMenu class="-ml-2 mr-[15px] mt-4 shrink-0" />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Barra laterale desktop -->
        <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:min-h-0 lg:w-64 lg:flex-col">
            <!-- Navigazione laterale desktop -->
            <div class="flex min-h-0 grow flex-col border-r border-white/10 bg-gradient-to-b from-indigo-950 via-indigo-900 to-indigo-900 pb-6 pl-6 pr-1 shadow-2xl">

                <div class="admin-sidebar-menu-scroll -ml-2 min-h-0 flex-1 overflow-x-hidden overflow-y-auto pl-2 pr-3 pt-6">
                    <!--
                    <form class="mb-4" action="#" method="GET">
                        <label for="desktop-sidebar-search" class="sr-only">Cerca</label>
                        <input
                            id="desktop-sidebar-search"
                            type="search"
                            name="search"
                            class="block w-full rounded-lg border border-white/10 bg-white/10 px-3 py-2 text-sm text-white placeholder:text-indigo-200/70 focus:border-indigo-200/60 focus:outline-none focus:ring-2 focus:ring-indigo-200/20"
                            placeholder="Cerca"
                        />
                    </form>
                    -->

                    <Menu></Menu>
                </div>

                <AdminSidebarUserMenu class="-ml-2 mr-[15px] mt-4 shrink-0" />
            </div>
        </div>

        <div class="lg:pl-64">

            <div class="sticky top-0 z-40 flex h-14 shrink-0 items-center bg-slate-100 px-4 lg:hidden">
                <button type="button" class="-m-2.5 rounded-xl p-2.5 text-slate-600 transition hover:bg-slate-100 hover:text-slate-900 lg:hidden" @click="sidebarOpen = true">
                    <span class="sr-only">Open sidebar</span>
                    <Bars3Icon class="size-6" aria-hidden="true"/>
                </button>
            </div>

            <main class="py-6">
                <div class="px-4 sm:px-6 lg:px-8">
                    <slot></slot>
                </div>
            </main>
        </div>

        <FlashMessages
            bottom="0"
            v-model="flashMessages"
        />

        <!--
          <LoadingOverlay v-if="overlayVisibility" />
          -->

    </div>

</template>

<script setup>

import { ref } from 'vue'
import AdminSidebarUserMenu from '@/components/admin/AdminSidebarUserMenu.vue'

import {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'

import {
    Bars3Icon,
    XMarkIcon,
} from '@heroicons/vue/24/outline'

const sidebarOpen       = ref(false)
</script>

<style scoped>
.admin-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.admin-header {
    flex-shrink: 0;
}

.admin-main {
    flex: 1;
    overflow: auto;
}

.admin-footer {
    flex-shrink: 0;
}

.admin-sidebar-menu-scroll {
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: rgb(165 180 252 / 0.55) rgb(49 46 129 / 0.35);
}

.admin-sidebar-menu-scroll::-webkit-scrollbar {
    width: 6px;
}

.admin-sidebar-menu-scroll::-webkit-scrollbar-track {
    border-radius: 9999px;
    background: rgb(49 46 129 / 0.35);
}

.admin-sidebar-menu-scroll::-webkit-scrollbar-thumb {
    border-radius: 9999px;
    background: rgb(165 180 252 / 0.55);
}

.admin-sidebar-menu-scroll::-webkit-scrollbar-thumb:hover {
    background: rgb(199 210 254 / 0.75);
}
</style>
